export default "__VITE_ASSET__DMSv9j$5__"